import { formatBalance } from '../../../reducers/wallet.reducer'
import { formatFiat } from '../../rightSide/walletComponent/WalletComponent'
import { store } from '../../../store'
import { useTranslation } from 'react-i18next'
import { BalanceBlock } from './ListView.styled'
import { getWallet } from '@src/reducers/wallet.helper'

export const Balance = ({ currency }) => {
  const wallet = getWallet(currency)
  const { t } = useTranslation()
  const NO_FUNDS_AVAILABLE = t('wallet.listView.noFundsAvailable', 'No funds available')

  if (wallet) {
    return (
      <BalanceBlock>
        <span>{formatBalance(wallet, false, false)}</span>
        {formatFiat(store.getState().wallet.rates, wallet)}
      </BalanceBlock>
    )
  }
  return <span>{NO_FUNDS_AVAILABLE}</span>
}
